import _ from "underscore";

import type { KeysOfType } from "type_aliases";

export type BreakdownNode<T = any> = T & {
  id: string | number
  parent: BreakdownNode<T>
  children: BreakdownNode<T>[]
  level: number
}

export class Breakdown<Type, R = Type> {
  constructor(config: BreakdownConfig<Type, R>) {
    this.breakdown = {};
    this.all = {};
    this.config = config;
  }

  getChildren(id: string | number, recursive?: boolean): BreakdownNode<R>[] {
    const node = this.all[id];
    if (node) {
      let childNodes = node.children.slice();
      if (recursive) {
        node.children.forEach(childNode => {
          childNodes.push(...this.getChildren(childNode.id));
        });
      }
      return _.compact(childNodes);
    } else {
      return [];
    }
  }

  config: BreakdownConfig<Type, R>;
  breakdown: { [id: string | number]: BreakdownNode<R> };
  all: { [id: string | number]: BreakdownNode<R> };
}

export type BreakdownConfig<Type = any, R = Type> = {
  id: KeysOfType<Type, string | number>
  parentId: KeysOfType<Type, string | number> | ((element: Type) => string | number)
  childIds?: KeysOfType<Type, string[] | number[]> | ((element: Type) => string[] | number[])
  transform?: (element: Type) => R
  transformedId?: KeysOfType<R, string | number>
  transformedParentId?: KeysOfType<R, string | number>
}
